import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { routes } from '@app/consts';
import { EmployeeSecurityService } from '@app/modules/talent-track/talent-track-edit-employee/edit-employee/components/employee-security/services/employee-security.service';
import { Localization } from '@app/shared/models/localization.model';
import { Culture } from '@app/shared/models/system-language/culture.model';

@Component({
  selector: 'app-edit-form-v3',
  templateUrl: './edit-form-v3.component.html',
  styleUrls: ['./edit-form-v3.component.scss']
})
export class EditFormV3Component implements OnInit {
  public routes: typeof routes = routes;
  formId: string;
  formName: string;
  private currentCulture: Culture;
  private formNames: Localization[] = [];

  constructor(
    private route: ActivatedRoute,
    private employeeSecurityService: EmployeeSecurityService,
  ) { }

  ngOnInit(): void {
    this.formId = this.route.snapshot.paramMap.get('id');

    this.employeeSecurityService.currentCulture$()
      .subscribe(res => {
        this.currentCulture = res;
        this.setFormName();
      });
  }

  // Called with the form's name localizations when it loads and again after its details are saved
  onFormLoaded(names: Localization[]) {
    this.formNames = names ?? [];
    this.setFormName();
  }

  private setFormName() {
    const match = this.formNames.find(name => name.culture === this.currentCulture?.id);
    this.formName = (match ?? this.formNames[0])?.text;
  }
}
